import type { AvatarProps, SxProps, Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

export const getLegendPointAvatarBackgroundStyles = (
  theme: Theme,
): SystemStyleObject<Theme> => ({
  bgcolor: theme.palette.background.secondary,
});

export const withLegendPointAvatarBackground =
  (extraSx?: AvatarProps['sx']): SxProps<Theme> =>
  (theme) => ({
    ...getLegendPointAvatarBackgroundStyles(theme),
    ...(typeof extraSx === 'function' ? extraSx(theme) : extraSx),
  });
